<template>
  <div class="container">

    <form @submit.prevent="submitIdentifyFile">
      <heading-one class="-margin-md">ご本人さま確認書類のご提出</heading-one>

      <errors-alert :errors="errors"></errors-alert>

      <slot name="wizard"></slot>

      <section v-if="identity === '01'">
        <heading-two>運転免許証</heading-two>

        <txt-top></txt-top>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>運転免許証アップロード時のご確認事項</card-header>
          <card-body>
            <p>以下をご確認ください。</p>
            <list-group class="-normal">
              <list-item class="-normal">お名前、生年月日、ご住所、有効期限、公印、運転免許証番号が記載されているかをご確認ください。</list-item>
              <list-item class="-normal">裏面に記載がある場合、裏面を必ず撮影してください。</list-item>
              <list-item class="-normal">本籍地の記載や臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</list-item>
            </list-group>
          </card-body>
        </card-box>

        <identity-point></identity-point>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>運転免許証（表）</heading-three>
            <div v-if="this.identifyFile.file_data1">
              <uploaded-image :file-data="identifyFile.file_data1" :file-name="identifyFile.file_name1"
                              @onDelete="() => {identifyFile.file_data1 = ''; identifyFile.file_name1 = ''; identifyFile.file_sbt1 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile1" @onDrop="setImgFile1" @error="showError" />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>運転免許証（裏）</heading-three>
            <div v-if="this.identifyFile.file_data2">
              <uploaded-image :file-data="identifyFile.file_data2" :file-name="identifyFile.file_name2"
                              @onDelete="() => {identifyFile.file_data2 = ''; identifyFile.file_name2 = ''; identifyFile.file_sbt2 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile2" @onDrop="setImgFile2" @error="showError"/>
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '02'">
        <heading-two>運転経歴証明書</heading-two>

        <txt-top></txt-top>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>運転経歴証明書アップロード時のご確認事項</card-header>
          <card-body>
            <p>以下をご確認ください。</p>
            <list-group class="-normal">
              <list-item class="-normal">運転経歴証明書は、2012年4月1日以降に交付されているもののみ受付が可能です。</list-item>
              <list-item class="-normal">お名前、生年月日、ご住所、公印、運転経歴証明書番号が記載されているかをご確認ください。</list-item>
              <list-item class="-normal">裏面に記載がある場合、裏面を必ず撮影してください。</list-item>
              <list-item class="-normal">本籍地の記載や臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</list-item>
            </list-group>
          </card-body>
        </card-box>

        <identity-point></identity-point>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>運転経歴証明書（表）</heading-three>
            <div v-if="this.identifyFile.file_data1">
              <uploaded-image :file-data="identifyFile.file_data1" :file-name="identifyFile.file_name1"
                              @onDelete="() => {identifyFile.file_data1 = ''; identifyFile.file_name1 = ''; identifyFile.file_sbt1 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile3" @onDrop="setImgFile1" @error="showError" />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>運転経歴証明書（裏）</heading-three>
            <div v-if="this.identifyFile.file_data2">
              <uploaded-image :file-data="identifyFile.file_data2" :file-name="identifyFile.file_name2"
                              @onDelete="() => {identifyFile.file_data2 = ''; identifyFile.file_name2 = ''; identifyFile.file_sbt2 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile4" @onDrop="setImgFile2" @error="showError"/>
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '03'">
        <heading-two>パスポート</heading-two>

        <txt-top></txt-top>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>パスポートアップロード時のご確認事項</card-header>
          <card-body>
            <p>顔写真ページ・所持人記入欄</p>
            <div class="row">
              <div class="col-12 col-md-5 _mb-sm-20">
                <img src="@/assets/images/identity/passport.jpg" class="img-fluid _px-sm-10 _px-md-20" alt="">
              </div>
              <div class="col-12 col-md-7">
                <p>以下をご確認ください。</p>
                <list-group class="-normal">
                  <list-item class="-normal">顔写真入りのページと所持人記入欄を撮影してください。</list-item>
                  <list-item class="-normal">顔写真入りのページに、お名前、生年月日、有効期限、旅券番号が記載されているかをご確認ください。</list-item>
                  <list-item class="-normal">所持人記入欄に、お名前、ご住所が記載されているかをご確認ください。</list-item>
                </list-group>
              </div>
            </div>
          </card-body>
        </card-box>

        <identity-point></identity-point>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>パスポート（顔写真入り）</heading-three>
            <div v-if="this.identifyFile.file_data1">
              <uploaded-image :file-data="identifyFile.file_data1" :file-name="identifyFile.file_name1"
                              @onDelete="() => {identifyFile.file_data1 = ''; identifyFile.file_name1 = ''; identifyFile.file_sbt1 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile5" @onDrop="setImgFile1" @error="showError" />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>パスポート（所持人記入欄）</heading-three>
            <div v-if="this.identifyFile.file_data2">
              <uploaded-image :file-data="identifyFile.file_data2" :file-name="identifyFile.file_name2"
                              @onDelete="() => {identifyFile.file_data2 = ''; identifyFile.file_name2 = ''; identifyFile.file_sbt2 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile6" @onDrop="setImgFile2" @error="showError"/>
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '04'">
        <heading-two>健康保険証</heading-two>

        <txt-top></txt-top>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>健康保険証アップロード時のご確認事項</card-header>
          <card-body>
            <p>紙型の保険証</p>
            <div class="row">
              <div class="col-12 col-md-5 _mb-sm-20">
                <img src="@/assets/images/identity/insurance-paper.jpg" class="img-fluid _px-sm-10 _px-md-20" alt="">
              </div>
              <div class="col-12 col-md-7">
                <p>以下をご確認ください。</p>
                <list-group class="-normal">
                  <list-item class="-normal">お名前、生年月日、ご住所が記載されている面を撮影してください。</list-item>
                  <list-item class="-normal">裏面にご住所の記載がある場合、裏面を必ず撮影してください。</list-item>
                  <list-item class="-normal">紙型の保険証の場合は、イラストのようにお名前、生年月日、ご住所が記載されている面をすべて撮影してください。</list-item>
                  <list-item class="-normal">住所が変更されている場合は、下記内容をご確認ください。
                    <list-group class="-normal">
                      <list-item>①住所を自分で書き入れる保険証：住所欄に新住所が記入されていることをご確認ください。</list-item>
                      <list-item>②住所を印字している保険証（国民健康保険など）：発行元での訂正・訂正印捺印がなされていることをご確認ください。</list-item>
                    </list-group>
                  </list-item>
                  <list-item class="-normal">保険者番号・記号・番号（介護保険の被保険者証および自衛官診療証を除く）、臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</list-item>
                </list-group>
              </div>
            </div>
          </card-body>
        </card-box>

        <identity-point></identity-point>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>健康保険証（表）</heading-three>
            <div v-if="this.identifyFile.file_data1">
              <uploaded-image :file-data="identifyFile.file_data1" :file-name="identifyFile.file_name1"
                              @onDelete="() => {identifyFile.file_data1 = ''; identifyFile.file_name1 = ''; identifyFile.file_sbt1 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile7" @onDrop="setImgFile1" @error="showError" />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>健康保険証（裏）</heading-three>
            <div v-if="this.identifyFile.file_data2">
              <uploaded-image :file-data="identifyFile.file_data2" :file-name="identifyFile.file_name2"
                              @onDelete="() => {identifyFile.file_data2 = ''; identifyFile.file_name2 = ''; identifyFile.file_sbt2 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile8" @onDrop="setImgFile2" @error="showError"/>
            </div>
          </div>
        </div>

      </section>

      <section v-if="identity === '05'">
        <heading-two>マイナンバーカード（顔写真付き）</heading-two>

        <txt-top></txt-top>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>マイナンバーカード（顔写真付き）アップロード時のご確認事項</card-header>
          <card-body>
            <div class="row">
              <div class="col-12 col-md-5 _mb-sm-20">
                <img src="@/assets/images/identity/mynumber-card.jpg" class="img-fluid _px-sm-10 _px-md-20" alt="">
              </div>
              <div class="col-12 col-md-7">
                <p>以下をご確認ください。</p>
                <list-group class="-normal">
                  <list-item class="-normal">お名前、生年月日、ご住所、有効期限が記載されているかをご確認ください。</list-item>
                  <list-item class="-normal">通知カード（写真なし）は本人確認資料として利用はできません。</list-item>
                  <list-item class="-normal">臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</list-item>
                </list-group>
              </div>
            </div>
          </card-body>
        </card-box>

        <identity-point></identity-point>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>マイナンバーカード（顔写真付き）</heading-three>
            <div v-if="this.identifyFile.file_data1">
              <uploaded-image :file-data="identifyFile.file_data1" :file-name="identifyFile.file_name1"
                              @onDelete="() => {identifyFile.file_data1 = ''; identifyFile.file_name1 = ''; identifyFile.file_sbt1 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile9" @onDrop="setImgFile1" @error="showError"/>
            </div>
          </div>
        </div>

      </section>

      <section v-if="showSubIdentityType && subIdentity === '01'">
        <heading-two>住民票の写し</heading-two>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>住民票の写しアップロード時のご確認事項</card-header>
          <card-body>
            <p>以下をご確認ください。</p>
            <list-group class="-normal">
              <list-item class="-normal">発行日から6ヶ月以内かどうかをご確認ください。</list-item>
              <list-item class="-normal">お名前、生年月日、ご住所、発行日が記載されているかをご確認ください。</list-item>
              <list-item class="-normal">本籍地、個人番号（マイナンバー）が記載されている場合は、読み取れないように付箋や紙などで隠して撮影してください。</list-item>
            </list-group>
          </card-body>
        </card-box>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>住民票の写し（ファイル１）</heading-three>
            <div v-if="this.identifyFile.file_data3">
              <uploaded-image :file-data="identifyFile.file_data3" :file-name="identifyFile.file_name3"
                              @onDelete="() => {identifyFile.file_data3 = ''; identifyFile.file_name3 = ''; identifyFile.file_sbt3 = '';}" />
            </div>
            <div v-else>
              <upload-image class="_mb-30" docType="identify" id="setImgFile10" @onDrop="setImgFile3" @error="showError"/>
            </div>
          </div>
        </div>
      </section>

      <section v-if="showSubIdentityType && subIdentity === '02'">
        <heading-two>公的書類</heading-two>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>公的書類アップロード時のご確認事項</card-header>
          <card-body>
            <p>以下のいずれかひとつを撮影してください。</p>

            <p>国税・地方税の領収書または納税証明書/社会保険料の領収書</p>
            <list-group class="-normal">
              <list-item class="-normal">発行日から6ヶ月以内かどうかをご確認ください。</list-item>
              <list-item class="-normal">お名前、ご住所、発行日が記載されているかをご確認ください。</list-item>
            </list-group>
            <p>公共料金の領収書</p>
            <list-group class="-normal">
              <list-item class="-normal">公共料金の領収書は、電気、都市ガス、水道、NHK、固定電話のみ受付が可能です。</list-item>
              <list-item class="-normal">発行日から6ヶ月以内かどうかをご確認ください。</list-item>
              <list-item class="-normal">お名前、ご住所、発行日が記載されているかをご確認ください。</list-item>
            </list-group>
          </card-body>
        </card-box>

        <div class="row">
          <div class="col-12 col-md-6">
            <heading-three>公的書類</heading-three>
            <div v-if="this.identifyFile.file_data3">
              <uploaded-image :file-data="identifyFile.file_data3" :file-name="identifyFile.file_name3"
                              @onDelete="() => {identifyFile.file_data3 = ''; identifyFile.file_name3 = ''; identifyFile.file_sbt3 = '';}" />
            </div>
            <div v-else>
              <upload-image class="_mb-30" docType="identify" id="setImgFile11" @onDrop="setImgFile3" @error="showError"/>
            </div>
          </div>
        </div>
      </section>

      <section v-if="showProofNationalityType && proofNationality === '03'">
        <heading-two>在留カード</heading-two>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>在留カードアップロード時のご確認事項</card-header>
          <card-body>
            <p>以下をご確認ください。</p>
            <list-group class="-normal">
              <list-item class="-normal">お名前、生年月日、ご住所、有効期限、公印、在留カード番号が記載されているかをご確認ください。</list-item>
              <list-item class="-normal">裏面に記載がある場合、裏面を必ず撮影してください。</list-item>
            </list-group>
          </card-body>
        </card-box>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>在留カード（表）</heading-three>
            <div v-if="this.identifyFile.file_data4">
              <uploaded-image :file-data="identifyFile.file_data4" :file-name="identifyFile.file_name4"
                              @onDelete="() => {identifyFile.file_data4 = ''; identifyFile.file_name4 = ''; identifyFile.file_sbt4 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile12" @onDrop="setImgFile4" @error="showError" />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>在留カード（裏）</heading-three>
            <div v-if="this.identifyFile.file_data5">
              <uploaded-image :file-data="identifyFile.file_data5" :file-name="identifyFile.file_name5"
                              @onDelete="() => {identifyFile.file_data5 = ''; identifyFile.file_name5 = ''; identifyFile.file_sbt5 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile13" @onDrop="setImgFile5" @error="showError"/>
            </div>
          </div>
        </div>
      </section>

      <section v-if="showProofNationalityType && proofNationality === '04'">
        <heading-two>特別永住者証明書</heading-two>

        <card-box class="_mb-sm-40 _mb-md-60">
          <card-header>特別永住者証明書アップロード時のご確認事項</card-header>
          <card-body>
            <p>以下をご確認ください。</p>
            <list-group class="-normal">
              <list-item class="-normal">お名前、生年月日、ご住所、有効期限、公印、特別永住者証明書番号が記載されているかをご確認ください。</list-item>
              <list-item class="-normal">裏面に記載がある場合、裏面を必ず撮影してください。</list-item>
            </list-group>
          </card-body>
        </card-box>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>特別永住者証明書（表）</heading-three>
            <div v-if="this.identifyFile.file_data4">
              <uploaded-image :file-data="identifyFile.file_data4" :file-name="identifyFile.file_name4"
                              @onDelete="() => {identifyFile.file_data4 = ''; identifyFile.file_name4 = ''; identifyFile.file_sbt4 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile14" @onDrop="setImgFile4" @error="showError" />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>特別永住者証明書（裏）</heading-three>
            <div v-if="this.identifyFile.file_data5">
              <uploaded-image :file-data="identifyFile.file_data5" :file-name="identifyFile.file_name5"
                              @onDelete="() => {identifyFile.file_data5 = ''; identifyFile.file_name5 = ''; identifyFile.file_sbt5 = '';}" />
            </div>
            <div v-else>
              <upload-image docType="identify" id="setImgFile15" @onDrop="setImgFile5" @error="showError"/>
            </div>
          </div>
        </div>
      </section>
      <btngroup-double class="-margin-lg">
        <btn-main slot="main" class="-main" @click.prevent="submitIdentifyFile">
          確認へ進む
        </btn-main>
        <btn-back slot="back" class="-back -sm" @click.prevent="goBack">
          戻る
        </btn-back>
      </btngroup-double>
    </form>
  </div>
</template>

<script>
import { initCredentials } from '../../utils/Auth'
import { validateEditIdentifyFileLambdaInvoke, getUserDataLambdaInvoke } from '../../utils/LambdaHelper'
import fileUpload from '../../components/mixin/FileUpload'

import HeadingOne from '../../components/heading/HeadingOne'
import HeadingTwo from '../../components/heading/HeadingTwo'
import HeadingThree from '../../components/heading/HeadingThree'
import errorsAlert from '../../components/alert/ErrorsAlert'
import InputError from '../../components/input/InputError'
import TooltipsItem from '../../components/tooltip/TooltipsItem'
import BtnMain from '../../components/button/BtnMain'
import BtnInput from '../../components/button/BtnInput'
import BtnBack from '../../components/button/BtnBack'
import BtngroupDouble from '../../components/button/BtngroupDouble'
import BtnTooltip from '../../components/button/BtnTooltip'
import BtnRadio from '../../components/button/BtnRadio'
import TableBox from '../../components/tables/TableBox'
import TableBody from '../../components/tables/TableBody'
import TableRow from '../../components/tables/TableRow'
import TableHeader from '../../components/tables/TableHeader'
import TableData from '../../components/tables/TableData'
import BadgeIcon from '../../components/badges/BadgeIcon'
import ListGroup from '../../components/list/ListGroup'
import ListItem from '../../components/list/ListItem'
import CardBox from '../../components/card/CardBox'
import CardHeader from '../../components/card/CardHeader'
import CardBody from '../../components/card/CardBody'
import UploadImage from '../../components/upload/UploadImage'
import UploadedImage from '../../components/upload/UploadedImage'
import MainWizard from '../../components/wizard/MainWizard'
import SubWizard from '../../components/wizard/SubWizard'
import WizardGroup from '../../components/wizard/WizardGroup'
import CardGroups from '../../components/card/CardGroups'
import IdentityPoint from '../../components/upload/IdentityPoint'
import TxtTop from '../upload/TxtTop'

export default {
  name: 'identify-select',
  components: {
    TxtTop,
    IdentityPoint,
    CardGroups,
    WizardGroup,
    SubWizard,
    MainWizard,
    CardBody,
    CardHeader,
    CardBox,
    BadgeIcon,
    BtnRadio,
    BtnTooltip,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne,
    HeadingTwo,
    HeadingThree,
    BtngroupDouble,
    TooltipsItem,
    errorsAlert,
    InputError,
    BtnMain,
    BtnBack,
    BtnInput,
    ListGroup,
    ListItem,
    UploadImage,
    UploadedImage
  },
  mixins: [fileUpload],
  props: {
    previousPageId: '',
    nextPageId: ''
  },
  data () {
    return {
      identity: this.$route.query.identity,
      subIdentity: this.$route.query.subIdentity,
      nationality: this.$route.query.nationality,
      proofNationality: this.$route.query.proofNationality,
      isDisabled: false,
      files: true,
      errors: {},
      identifyFile: {
        identity: this.$route.query.identity,
        subIdentity: this.$route.query.subIdentity,
        nationality: this.$route.query.nationality,
        proofNationality: this.$route.query.proofNationality,
        processing_type: '1',
        file_name1: '',
        file_data1: '',
        file_sbt1: '',
        file_name2: '',
        file_data2: '',
        file_sbt2: '',
        file_name3: '',
        file_data3: '',
        file_sbt3: '',
        file_name4: '',
        file_data4: '',
        file_sbt4: '',
        file_name5: '',
        file_data5: '',
        file_sbt5: '',
        file_name6: '',
        file_data6: '',
        file_sbt6: ''
      }
    }
  },
  methods: {
    submitIdentifyFile: function (event) {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.identifyFile.processing_type = '1'
        this.checkQueryParam()
        initCredentials().then(res => {
          validateEditIdentifyFileLambdaInvoke(this.identifyFile).then(res => {
            this.errors = {}
            if (res.errors) {
              for (let e in res.errors) {
                let key = e
                if (e.indexOf('file_data') !== -1) {
                  if (e === 'file_data1' || e === 'file_data2') {
                    key += '_' + this.identity
                  } else if (e === 'file_data3') {
                    key += '_' + this.subIdentity
                  } else if (e === 'file_data4' || e === 'file_data5') {
                    key += '_' + this.proofNationality
                  }
                  this.errors[key] = res.errors[e]
                  if (this.errors[key].length > 0) {
                    this.errors[key][0] = this.errors[key][0].replace('empty', 'unselect')
                  }
                }
              }
              this.scrollTop()
              this.isDisabled = false
            } else {
              let queryParam = {
                identity: this.identity || '00',
                subIdentity: this.subIdentity || '00',
                nationality: this.nationality || '02',
                proofNationality: this.proofNationality || '00'
              }
              this.$router.push({name: this.nextPageId, query: queryParam})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    goBack: function () {
      try {
        let queryParam = {
          identity: this.identity || '00',
          subIdentity: this.subIdentity || '00',
          nationality: this.nationality || '02',
          proofNationality: this.proofNationality || '00'
        }
        this.$router.push({name: this.previousPageId, query: queryParam})
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    checkQueryParam () {
      try {
        if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendering) {
          // ビルド時の静的ファイル生成時はチェックしない
          return
        }
        if (['01', '02', '03', '04', '05'].indexOf(this.$route.query.identity) === -1) {
          this.$router.push({name: this.previousPageId})
        }
        if (['04', '05'].indexOf(this.$route.query.subIdentity) !== -1) {
          if (['01', '02'].indexOf(this.$route.query.subIdentity) === -1) {
            this.$router.push({name: this.previousPageId})
          }
        }
        if (['01', '02'].indexOf(this.$route.query.nationality) === -1) {
          this.$router.push({name: this.previousPageId})
        }
        if (['02'].indexOf(this.$route.query.nationality) !== -1) {
          if (['03', '04'].indexOf(this.$route.query.proofNationality) === -1) {
            this.$router.push({name: this.previousPageId})
          }
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  },
  created () {
    this.checkQueryParam()
  },
  mounted () {
    try {
      getUserDataLambdaInvoke(this.files).then(res => {
        for (let key in res) {
          if (this.identifyFile.hasOwnProperty(key)) {
            if (['file_name6', 'file_data6', 'file_sbt6'].indexOf(key) > -1) {
              // file6は使わない
              continue
            }
            if (this.identity === '05') {
              // マイナンバーカードは表のみ
              if (['file_name2', 'file_data2', 'file_sbt2'].indexOf(key) > -1) {
                continue
              }
            }
            if (this.identity !== '04' && this.identity !== '05') {
              // 健康保険証とマイナンバーカード以外は住民票、公的書類は提出しない
              if (['file_name3', 'file_data3', 'file_sbt3'].indexOf(key) > -1) {
                continue
              }
            }
            if (this.nationality !== '02') {
              // 日本国籍の人は、在留カードと永住者証明書は不要
              if (['file_name4', 'file_data4', 'file_sbt4', 'file_name5', 'file_data5', 'file_sbt5'].indexOf(key) > -1) {
                continue
              }
            }
            this.identifyFile[key] = res[key]
          }
        }
        if (res['file_sbt1'] !== this.getIdentityFileSbt()) {
          this.identifyFile.file_name1 = ''
          this.identifyFile.file_data1 = ''
          this.identifyFile.file_sbt1 = ''
        }
        if (res['file_sbt2'] !== this.getIdentityFileSbt()) {
          this.identifyFile.file_name2 = ''
          this.identifyFile.file_data2 = ''
          this.identifyFile.file_sbt2 = ''
        }
        if (res['file_sbt3'] !== this.getSubIdentityFileSbt()) {
          this.identifyFile.file_name3 = ''
          this.identifyFile.file_data3 = ''
          this.identifyFile.file_sbt3 = ''
        }
        if (res['file_sbt4'] !== this.getNationalityFileSbt()) {
          this.identifyFile.file_name4 = ''
          this.identifyFile.file_data4 = ''
          this.identifyFile.file_sbt4 = ''
        }
        if (res['file_sbt5'] !== this.getNationalityFileSbt()) {
          this.identifyFile.file_name5 = ''
          this.identifyFile.file_data5 = ''
          this.identifyFile.file_sbt5 = ''
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";

  .dropImage {
    border: 1px #999 dashed;
  }
</style>



// WEBPACK FOOTER //
// src/components/fileupload/IdentifySelect.vue